"use client";

import { createContext, useContext } from "react";

import type { RashiId } from "@ishvaram/domain-data/rashis";

/**
 * How the Moon-sign check (_moon-check/ShaniMoonCheck, in its own async
 * chunk) selects a sign in the page's picker. ShaniTransitSurface renders the
 * check into ShaniTransitClient as a slot, so the client never imports the
 * check, the kundali client or the verdict (tests/transit-now-island.test.ts);
 * the slot still renders inside the client's tree, so this context reaches it.
 * Outside a provider, selecting does nothing.
 */
export interface ShaniRashiSelection {
  /** Select the sign in the picker and bring its result panel into view. */
  select: (rashi: RashiId) => void;
}

const NO_PICKER: ShaniRashiSelection = { select: () => {} };

export const ShaniRashiSelectionContext = createContext<ShaniRashiSelection>(NO_PICKER);

export function useShaniRashiSelection(): ShaniRashiSelection {
  return useContext(ShaniRashiSelectionContext);
}
